import React, { useEffect, useState, useCallback, memo } from 'react';
import { Box } from '@chakra-ui/react';

import { Toolbar, Table } from './components';
import { RouteComponentProps } from 'react-router';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import useEventBus from 'hooks/useEventBus';
import { listLawyer } from 'services/lawyers';

import { ModalChangeStatus } from './components/Toolbar/components/ModalChangeStatus';

interface IProps extends RouteComponentProps {}

const LawyerManagementComp: React.FC<IProps> = ({ history }) => {
  const [data, setData] = useState<any>({ content: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [searchDemand] = useState(false);

  const eventBus = useEventBus();
  const [update, setUpdate] = useState<boolean>(false);

  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Gerenciamento de Advogados');
  }, []);

  const handleGetData = useCallback(async (query?: string) => {
    setIsLoading(true);

    try {
      const defaultQuery = `size=10`;
      let newQuery = `?${defaultQuery}`;

      if (query) {
        if (query[0] === '?') {
          newQuery = `${query}&${defaultQuery}`;
        } else {
          newQuery = `?${query}&${defaultQuery}`;
        }
      }

      if (newQuery.includes('?')) {
        newQuery = newQuery.slice(1);
      }

      const response = await listLawyer(newQuery);

      setData(response.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, []);
  const handlePaginate = (newPage: number) => {
    const newFilterData = queryToObj(history.location.search);

    function valuePositive(value: number) {
      const query = localStorage.getItem('queryPageDemands') || '';
      if (value === -1) {
        return 0;
      } else if (value === Number(query)) {
        return Math.abs(Number(query));
      } else {
        return Math.abs(value - 1);
      }
    }

    setTimeout(() => {
      localStorage.removeItem('queryPageDemands');
    }, 1000);

    const query = objToQuery({ ...newFilterData, page: valuePositive(newPage) });
    if (
      newFilterData.page &&
      typeof newFilterData.page === 'string' &&
      newPage - 1 === parseInt(newFilterData.page)
    )
      return;

    history.replace({
      pathname: routePaths.lawyerManagement,
      search: `?${query}`,
    });
  };

  useEffect(() => {
    handleGetData(history.location.search);
    const removeListen = history.listen(listener => handleGetData(listener.search));
    return () => {
      removeListen();
    };
  }, [searchDemand, update]);

  return (
    <Box w="100%">
      <Toolbar history={history} setUpdate={setUpdate} />
      <Box padding="0.1rem 0rem 1rem" background="#fff" borderRadius="10px">
        <Table
          loading={isLoading}
          row={[0]}
          headers={['Advogado', '', '', '', '', '', '', '', 'Status']}
          sizes={[1, 1, 1, 1, 1, 1, 1, 1, 1, 0.1]}
          fullLoading={false}
          handles={[]}
          buttons={data?.content.map(() => (
            <></>
          ))}
          rows={data?.content.map((demand: any) => [
            demand?.name,
            ' ',
            ' ',
            ' ',
            ' ',
            ' ',
            ' ',
            ' ',
            // eslint-disable-next-line react/jsx-key
            <ModalChangeStatus demand={demand} setUpdate={setUpdate} />,
          ])}
          pagination={{
            initialPage: Number(localStorage.getItem('queryPageDemands')) + 1 ?? 1,
            onChange: handlePaginate,
            pagesCount: data?.totalPages || 1,
          }}
        />
      </Box>
    </Box>
  );
};

export const LawyerManagement = memo(LawyerManagementComp);
